import * as React from 'react';
import './index.css';
import Highlight from './highlight';

const Row = ({ parameter, type, description, index }) => (
  <div className="row" style={{ backgroundColor: `${index % 2 == 0 ? '#F9FAFB' : '#FFFFFF'}` }}>
    <div className="startRow">
      <Highlight content={parameter} />
    </div>
    <div className="middleRow">{type}</div>
    <div className="endRow">{description}</div>
  </div>
);

/*
    Table component written as an ES6 class
  */
const Table = ({ data }) => {
  const [columns, setColumns] = React.useState(data);

  const rows = columns?.map((rowData, index) => <Row {...rowData} index={index} />);

  return (
    <div className="table">
      <div className="header">
        <div className="startHead">Parameter</div>
        <div className="middleHead">Type </div>
        <div className="endHead">Description</div>
      </div>
      <div className="body">{rows}</div>
    </div>
  );
};

export default Table;
/*
 * Render the above component into the div#app
 */
